module.exports = __webpack_public_path__ + "img/no_filtered_chores.d4d7bf02.svg";